import { render, staticRenderFns } from "./BySegment.vue?vue&type=template&id=4886026c"
import script from "./BySegment.vue?vue&type=script&lang=js"
export * from "./BySegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports